import {useMemo} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {backgroundColor, calculateRemSize, ml} from "@pg-design/helpers-css";

import {IOfferStageStatus} from "../../types/IOfferGroups";

interface IProps {
    status: IOfferStageStatus;
}

export const OfferStageStatus = ({status}: IProps) => {
    const theme = useTheme();

    const dotColor = useMemo(() => {
        switch (status) {
            case IOfferStageStatus.SOLD:
            case IOfferStageStatus.IN_PREPARATION: {
                return theme.colors.gray[600];
            }
            case IOfferStageStatus.ON_HOLD: {
                return theme.colors.info;
            }
            default:
            case IOfferStageStatus.FOR_SALE: {
                return "#02D054";
            }
        }
    }, []);

    return <div css={[backgroundColor(dotColor), dot]} />;
};

const dot = (theme: Theme) => css`
    min-width: ${calculateRemSize(2)};
    min-height: ${calculateRemSize(2)};
    max-width: ${calculateRemSize(2)};
    max-height: ${calculateRemSize(2)};
    border-radius: ${calculateRemSize(2)};
    border: 1px solid ${theme.colors.secondary};
    ${ml(2)};
`;
